import React, { useState } from 'react';
import './ImportSpreadsheetModal.css';
import { SERVER_URL } from '../../constants/server-type';
import { toast } from 'react-toastify';

export default function ImportSpreadsheetModal({
  open,
  onClose
}) {

  const [projectName, setProjectName] = useState('');
  const [templateName, setTemplateName] = useState('');
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [templateEdited, setTemplateEdited] = useState(false);


  if (!open) return null;

  const handleProjectChange = (e) => {

    const value = e.target.value;

    setProjectName(value);

    if (!templateEdited) {

      setTemplateName(
        `${value} Template`
      );

    }

  };

  const handleImport = async () => {

    try {

      if (!projectName.trim()) {
        toast.warning('Project Name is required');
        return;
      }

      if (!templateName.trim()) {
        toast.warning('Template Name is required');
        return;
      }

      if (!file) {
        toast.warning('Please select a spreadsheet');
        return;
      }

      setSaving(true);

      const formData =
        new FormData();

      formData.append(
        'projectName',
        projectName
      );

      formData.append(
        'templateName',
        templateName
      );

      formData.append(
        'file',
        file
      );

      const token =
        localStorage.getItem(
          'accessToken'
        );

      const activeOrg =
        localStorage.getItem(
          'activeOrgId'
        );


      const res = await fetch(`${SERVER_URL}/datasets/importSpreadsheet`,

        {
          method: 'POST',

          headers: {

            Authorization:
              `Bearer ${token}`,

            'x-org-id':
              activeOrg

          },

          credentials:
            'include',

          body:
            formData

        }

      );

      const data =
        await res.json();

      if (!res.ok) {

        throw new Error(
          data.message ||
          'Import failed'
        );

      }

      toast.success(
        `${data.recordsImported} records imported successfully`
      );

      onClose(true);

    } catch (err) {

      console.error(
        'Import failed',
        err
      );

      toast.error(
        err.message ||
        'Import failed'
      );

    } finally {

      setSaving(false);

    }

  };

  return (

    <div className="import-modal-overlay">

      <div className="import-modal">

        <h2>
          Create Project From Spreadsheet
        </h2>

        <div className="import-form-group">

          <label>
            Project Name
          </label>

          <input
            type="text"
            value={projectName}
            onChange={handleProjectChange}
          />

        </div>

        <div className="import-form-group">

          <label>
            Template Name
          </label>

          <input
            type="text"
            value={templateName}
            onChange={(e) => {
              const value = e.target.value;
              setTemplateName(value);
              setTemplateEdited(value.trim() !== '' );
            }}
          />

        </div>

        <div className="import-form-group">

          <label>
            Spreadsheet
          </label>

          <input
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={(e) =>
              setFile(
                e.target.files?.[0]
              )
            }
          />

        </div>

        <div className="import-buttons">

          <button
            className="btn-gray"
            onClick={() =>
              onClose(false)
            }
            disabled={saving}
          >
            Cancel
          </button>

          <button
            className="btn-primary"
            onClick={handleImport}
            disabled={saving}
          >
            {
              saving
                ? 'Importing...'
                : 'Import'
            }
          </button>

        </div>

      </div>

    </div>

  );

}
